<template>
  <div>
    <div v-if="!loading">
      <Lynx-Title :text="form.name" v-if="form.id && form.name" v-once />
      <Lynx-Title text="Editar usuário" v-else />
      <form class="flex flex-col" @submit.prevent="onSubmit">
        <label class="w-full block px-1 tracking-wide text-gray-700 text-xs">
          <Lynx-Label
            label="Nome"
            :validator="$v.form.name"
            :validations-message="validationsMessage.form.name"
          />
          <Lynx-Input
            placeholder="Insira seu nome"
            :error="$v.form.name.$error"
            v-model.trim="$v.form.name.$model"
          />
        </label>
        <label class="w-full block px-1 tracking-wide text-gray-700 text-xs">
          <Lynx-Label
            label="Email"
            :validator="$v.form.email"
            :validations-message="validationsMessage.form.email"
          />
          <Lynx-Input
            placeholder="Insira seu email"
            :error="$v.form.email.$error"
            v-model.trim="$v.form.email.$model"
          />
        </label>
        <label class="w-full block px-1 tracking-wide text-gray-700 text-xs">
          <Lynx-Label label="Senha" />
          <Lynx-Input
            placeholder="Insira a senha"
            type="password"
            v-model.trim="form.password"
          />
        </label>
        <label class="w-full block px-1 tracking-wide text-gray-700 text-xs">
          <Lynx-Label label="Confirme a senha" type="password" />
          <Lynx-Input
            placeholder="Confirme a senha"
            type="password"
            v-model.trim="form.password_confirmation"
          />
        </label>
        <div class="pb-8">
          <span
            class="text-lg font-display border-b border-neutral-400 w-full pb-2 flex mb-4"
            >Permissões</span
          >
          <div class="flex flex-wrap">
            <label
              class="flex pr-8 pb-4"
              v-for="permission in permissions"
              :key="permission.id"
            >
              <b-checkbox
                v-model="form.permissions"
                :native-value="permission.name"
              />
              <span class="pl-1" v-text="permission.name"></span>
            </label>
          </div>
        </div>
        <div class="flex justify-between">
          <router-link :to="{ name: 'users.index' }">
            <Lynx-Button size="is-normal" class="is-light" text="Voltar" />
          </router-link>
          <Lynx-Button
            size="is-normal"
            class="is-success"
            type="submit"
            text="Salvar"
            :loading="loadingButton"
          />
        </div>
      </form>
    </div>
    <Lynx-OverlaySpinner v-else :loading="loading" />
  </div>
</template>

<script>
import {
  usersShowRequest,
  usersUpdateRequest,
} from "../../services/requests/users";
import { rolesUserShowRequest } from "../../services/requests/roles";

import { required, email } from "vuelidate/lib/validators";

export default {
  name: "UsersShow",
  data() {
    return {
      form: {},
      loading: false,
      loadingButton: false,
      validationsMessage: {
        form: {
          name: {
            required: "Insira seu nome completo",
          },
          email: {
            email: "Insira um email válido",
          },
        },
      },
      roles: [],
      permissions: [],
    };
  },
  validations: {
    form: {
      name: { required },
      email: { email },
    },
  },
  methods: {
    getErrors(error) {
      const errors = Object.values(error.response.data.errors);
      const message = errors
        .map((item) => item.map((error) => `<li>${error}</li>`).join(""))
        .join("");

      this.$buefy.dialog.alert({
        title: "Não foi possível salvar o usuário",
        message: `<ul>${message}</ul>`,
        type: "is-danger",
        ariaRole: "alertdialog",
        ariaModal: true,
      });
    },
    fetchUser() {
      this.loading = true;
      const userId = this.$route.params.id;
      usersShowRequest(userId)
        .then((res) => {
          this.form = res.data.data;
        })
        .catch(() => {
          this.$router.push({ name: "users.index" });
          this.$snack.error("Usuário não encontrado");
        })
        .finally(() => (this.loading = false));
    },
    fetchRoles() {
      rolesUserShowRequest().then((res) => {
        this.roles = res.data.data;
        this.permissions = this.roles?.permissions;
      });
    },
    onSubmit() {
      if (!this.form.permissions.length) {
        this.$snack.error("Selecione no mínimo uma permissão para o usuário");
        return;
      }
      const permissions = this.form.permissions;
      const form = {
        id: this.form.id,
        name: this.form.name,
        email: this.form.email,
        password: this.form?.password ? this.form.password : null,
        password_confirmation: this.form?.password_confirmation
          ? this.form?.password_confirmation
          : null,
        permissions,
      };
      this.loadingButton = true;
      usersUpdateRequest(form)
        // eslint-disable-next-line no-unused-vars
        .then((res) => {
          this.$snack.success("Usuário editado com sucesso");
          this.$router.push({ name: "users.index" });
        })
        // eslint-disable-next-line no-unused-vars
        .catch((err) => this.getErrors(err))
        .finally(() => (this.loadingButton = false));
    },
  },
  mounted() {
    this.fetchUser();
    this.fetchRoles();
  },
};
</script>
